module.exports = __webpack_public_path__ + "img/xu4.abb7fd28.png";